import { AxiosPromise, AxiosStatic } from "axios";
import { TSimpleMessage, TUnscheduleNotificationPayload } from "../types";

const unscheduledNotifications =
  (serverURL: string, appAxios: AxiosStatic, token: string) =>
  async (
    notifications: TUnscheduleNotificationPayload
  ): AxiosPromise<TSimpleMessage> =>
    await appAxios.post(
      `${serverURL}/admin/unschedule-notification`,
      notifications,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );

export default unscheduledNotifications;
